import Axios from "axios";
import { useEffect, useReducer } from "react";
import { systemCode } from '..';
import { dataFetchReducer } from "./utils/dataFetchReducer";
import { parseExtraEvents } from "./parseExtraEvent";
import { getConfiguration } from './utils/configuration';

export function useFetchExtraEvents(prematchData) {
    const [state, dispatch] = useReducer(dataFetchReducer, {
        isLoading: true,
        isError: false,
    });
    
    useEffect(() => {
        let didCancel = false;
    
        const fetchData = async (url, params, callback) => {
            dispatch({ type: 'FETCH_INIT' });
            try {
                const result = await Axios.get(url, {params});
                if (!didCancel) {
                    callback(result.data);
                }
            } catch (error) {
                console.error('Errore ' + url + ': ' + error);
                if (!didCancel) {
                    dispatch({ type: 'FETCH_FAILURE' });
                }
            }
        };
    
        const url = getConfiguration().api.getExtraEvents
        const params = {
            systemCode,
            hash: '',
        };
        fetchData(url, params, function(response) {
            const data = parseExtraEvents(prematchData, response);
            dispatch({ type: 'FETCH_SUCCESS', payload: data });
        });
        
        return () => {
            didCancel = true;
        };
    }, []);

    return [state, dispatch];
}
